import styles from "../css/learn.module.css";
import { Link } from "react-router-dom";
import CourseTile from "../components/cards/CourseTile";
import webdev from "../assets/webdev.png";
import html from "../assets/html5.png";
import css from "../assets/css3.png";
import javascript from "../assets/javascript.png";
import bootstrap from "../assets/bootstrap.png";
import frontend from "../assets/frontend.png";
import react from "../assets/react.png";
import office from "../assets/office.png";
import affiliate from "../assets/affiliate.png";
import influencer from "../assets/influencer.png";
import copywriting from "../assets/copywriting.png";
// import word from "../assets/word.png";
// import excel from "../assets/excel.png";
// import powerpoint from "../assets/powerpoint.png";
import coreldraw from "../assets/coreldraw.png";
import figma from "../assets/figma.png";
import digital from "../assets/digital.png";
import graphics from "../assets/graphics.png";
import LearnHeader from "../components/layout/LearnHeader";

function Learn() {
  return (
    <>
      <LearnHeader />
      <div className="container py-1">
        <div className="row">
          <div className="col-md-3 col-sm-6 col-6">
            <Link className={styles.learnLink} to="frontend">
              <CourseTile
                title="Frontend Dev"
                price={200000}
                destination="Online"
                date="9th January 2023"
                courseImage={frontend}
                description="The front end developer makes sure that the design works online by using coding languages such as CSS, HTML, JavaScript and React. "
              />
            </Link>
          </div>
          <div className="col-md-3 col-sm-6 col-6">
            <Link className={styles.learnLink} to="webdevelopment">
              <CourseTile
                title="Web Development"
                price={100000}
                destination="Online Class"
                date="9th January 2023"
                courseImage={webdev}
                description="Learn to Design and create Websites, Build a responsive and accessible web portfolio using HTML5, CSS3, Javascript & Bootstrap"
              />
            </Link>
          </div>
          <div className="col-md-3 col-sm-6 col-6">
            <Link className={styles.learnLink} to="digital">
              <CourseTile
                title="Digital Marketing"
                price={30000}
                destination="Online Class"
                date="9th January 2023"
                courseImage={digital}
                description="Digital marketing is a means of advertising and selling products through the internet, mobile devices, social media, search engines, display advertising, e.t.c. 
                "
              />
            </Link>
          </div>
          <div className="col-md-3 col-sm-6 col-6">
            <Link className={styles.learnLink} to="office">
              <CourseTile
                title="Microsoft Office"
                price={70000}
                destination="Online Class"
                date="9th January 2023"
                courseImage={office}
                description="Learning about applications under the world of Microsoft."
              />
            </Link>
          </div>
          <div className="col-md-3 col-sm-6 col-6">
            <Link className={styles.learnLink} to="graphics">
              <CourseTile
                title="Graphic Design"
                price={50000}
                destination="Online Class"
                date="9th January 2023"
                courseImage={graphics}
                description="Graphic design is the creation of visual compositions to solve problems and communicate ideas through typography, imagery, color and form."
              />
            </Link>
          </div>
          <div className="col-md-3 col-sm-6 col-6">
            <Link className={styles.learnLink} to="uiux">
              <CourseTile
                title="Design with Figma"
                price={60000}
                destination="Online Class"
                date="9th January 2023"
                courseImage={figma}
                description="Figma is a powerful design tool that helps you to create anything: websites, applications, logos, and much more."
              />
            </Link>
          </div>
          <div className="col-md-3 col-sm-6 col-6">
            <Link className={styles.learnLink} to="coreldraw">
              <CourseTile
                title="Corel Draw"
                price={40000}
                destination="Online Class"
                date="9th January 2023"
                courseImage={coreldraw}
                description="Learning the fundamentals of Corel Draw. "
              />
            </Link>
          </div>
          <div className="col-md-3 col-sm-6 col-6">
            <Link className={styles.learnLink} to="html">
              <CourseTile
                title="HTML"
                price={20000}
                destination="Online Class"
                date="9th January 2023"
                courseImage={html}
                description="Learn HTML with codecamp fundamentals course. HTML is the standard markup language for creating Web pages. "
              />
            </Link>
          </div>
          <div className="col-md-3 col-sm-6 col-6">
            <Link className={styles.learnLink} to="css">
              <CourseTile
                title="CSS"
                price={20000}
                destination="Online Class"
                date="9th January 2023"
                courseImage={css}
                description="Learn the fundamentals of CSS, CSS is a standard style sheet language used for describing the presentation (i.e. the layout and formatting) of the web pages "
              />
            </Link>
          </div>
          <div className="col-md-3 col-sm-6 col-6">
            <Link className={styles.learnLink} to="javascript">
              <CourseTile
                title="Javascript"
                price={50000}
                destination="Online Class"
                date="9th January 2023"
                courseImage={javascript}
                description="Learn the fundamentals of Javascript, JavaScript is designed to add interactivity and dynamic effects to the web pages by manipulating the content returned from a web server."
              />
            </Link>
          </div>
          <div className="col-md-3 col-sm-6 col-6">
            <Link className={styles.learnLink} to="bootstrap">
              <CourseTile
                title="Bootstrap "
                price={15000}
                destination="Online Class"
                date="9th January 2023"
                courseImage={bootstrap}
                description="Learn Bootstrap, Bootstrap gives you ability to create flexible and responsive web layouts with much less efforts."
              />
            </Link>
          </div>
          <div className="col-md-3 col-sm-6 col-6">
            <Link className={styles.learnLink} to="react">
              <CourseTile
                title="React JS"
                price={100000}
                destination="Online Class"
                date="9th January 2023"
                courseImage={react}
                description="Learn React,React is a JavaScript library for building user interfaces"
              />
            </Link>
          </div>
          <div className="col-md-3 col-sm-6 col-6">
            <Link className={styles.learnLink} to="affiliate">
              <CourseTile
                title="Affiliate Marketing"
                price={20000}
                destination="Online Class"
                date="9th January 2023"
                courseImage={affiliate}
                description="Learn the fundamentals of Affiliate marketing."
              />
            </Link>
          </div>
          <div className="col-md-3 col-sm-6 col-6">
            <Link className={styles.learnLink} to="influencer">
              <CourseTile
                title="Influencer Marketing"
                price={50000}
                destination="Online Class"
                date="9th January 2023"
                courseImage={influencer}
                description="Learn the fundamentals of Influencer marketing. "
              />
            </Link>
          </div>
          <div className="col-md-3 col-sm-6 col-6">
            <Link className={styles.learnLink} to="copywriting">
              <CourseTile
                title="Copywriting"
                price={35000}
                destination="Online Class"
                date="9th January 2023"
                courseImage={copywriting}
                description="Learn about Copywriting.Copywriting is the act or occupation of writing text for the purpose of advertising or other forms of marketing. 
                "
              />
            </Link>
          </div>
          {/* <div className="col-md-3 col-sm-6 col-6">
            <Link className={styles.learnLink} to="word">
              <CourseTile
                title="Microsoft Word"
                price={20000}
                destination="Online Class"
                date="21st September 2022"
                courseImage={word}
                description="Learn about the fundamentals of Microsoft Word. Microsoft Word is a word-processing program, designed to help you create professional-quality documents. "
              />
            </Link>
          </div>
          <div className="col-md-3 col-sm-6 col-6">
            <Link className={styles.learnLink} to="powerpoint">
              <CourseTile
                title="Microsoft Power Point"
                price={30000}
                destination="Online Class"
                date="21st September 2022"
                courseImage={powerpoint}
                description="Learn about the fundamentals of Microsoft PowerPoint."
              />
            </Link>
          </div>
          <div className="col-md-3 col-sm-6 col-6">
            <Link className={styles.learnLink} to="excel">
              <CourseTile
                title="Microsoft Excel"
                price={40000}
                destination="Online Class"
                date="21st September 2022"
                courseImage={excel}
                description="Learn about the fundamentals of Microsoft Excel. Microsoft Excel enables users to format, organise and calculate data in a spreadsheet. "
              />
            </Link>
          </div> */}
        </div>
      </div>
    </>
  );
}

export default Learn;
